import React from 'react';
import { Grid } from '@material-ui/core';

import { ModuleForm } from 'views/Lesson/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ModuleForm />
    </div>
  );
};
